export class TemplateRevisions {
  constructor(template) {
    this.template = template;
    this.reference = this.template.reference;
    this.revisions = this.template.revisions;
  }

  getRevisions() {
    if (this.reference && this.reference.revisions)
      return this.reference.revisions.length ? this.reference.revisions : [];

    return this.revisions && this.revisions.length ? this.revisions : [];
  }

  latestRevision() {
    const revs = this.getRevisions();
    return revs.length
      ? Math.max.apply(
          null,
          revs.map((rev) => rev.id)
        )
      : this.template.id;
  }

  isLatest(compareId) {
    const lastRev = this.latestRevision();
    return lastRev === compareId;
  }
}
